export interface Insurance {
  readonly _id?: string;
  readonly patientId?: string;
  readonly clientId?: string;
  readonly order?: number;
  readonly type?: InsuranceType;
  readonly status?: InsuranceStatus;
  readonly policyHolder?: InsurancePolicyHolder;
  readonly providerId?: string;
  readonly providerName?: string;
  readonly memberId?: string;
  readonly memberFirstName?: string;
  readonly memberLastName?: string;
  readonly groupId?: string;
  readonly payerId?: string;
  readonly isHidden?: boolean;
  readonly isPrimary?: boolean;
  readonly created?: string;
  readonly updated?: string;
  readonly deleted_time?: string;
}

export const enum InsuranceStatus {
  ACTIVE = 'active',
  CANCELLED = 'cancelled'
}
export const enum InsuranceType {
  MEDICAL = 'medical',
  MEDICAID = 'medicaid',
  MEDICARE = 'medicare',
  TRICARE = 'tricare',
  CHAMPVA = 'champva',
  GROUP = 'group',
  FECA = 'feca',
  BLACK_LUNG = 'black_lung'
}
export const enum InsurancePolicyHolder {
  SELF = 'self',
  SPOUSE = 'spouse',
  GUARDIAN = 'guardian',
  GUARANTOR = 'guarantor',
  OTHER = 'other'
}
